'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _reactIntl = require('react-intl');

var _url_utility = require('../../../packages/common-utilities/src/url_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedirectToFundDocuments = function (_React$PureComponent) {
    _inherits(RedirectToFundDocuments, _React$PureComponent);

    function RedirectToFundDocuments(props) {
        _classCallCheck(this, RedirectToFundDocuments);

        return _possibleConstructorReturn(this, (RedirectToFundDocuments.__proto__ || Object.getPrototypeOf(RedirectToFundDocuments)).call(this, props));
    }

    _createClass(RedirectToFundDocuments, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                country = _props.country,
                role = _props.role,
                language = _props.language,
                messageKey = _props.messageKey,
                isAEM = _props.isAEM;

            return _react2.default.createElement(
                'div',
                { 'data-testid': 'error-message', className: 'font-red text-center' },
                _string_utility2.default.renderFormattedLabel("This fund is no longer available. You will be redirected to Funds Document Page in 3 seconds.", messageKey),
                _react2.default.createElement(
                    'div',
                    { 'data-testid': 'redirect-to-fund-documents', className: 'font-white' },
                    this.props.window.setTimeout(function () {
                        _this2.props.window.setTimeout(function () {
                            _this2.props.window.location = (0, _url_utility.generateFundDocLink)(country, language, role, isAEM);
                        }, 3000);
                    }, 1)
                )
            );
        }
    }]);

    return RedirectToFundDocuments;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(RedirectToFundDocuments);